import { CheckCircle } from "lucide-react";
import Wordmark from "../components/Wordmark";

export default function PaymentSuccess() {
  return (
    <div className="min-h-screen bg-[#0F0F0F] flex flex-col items-center justify-center px-4 text-center">
      <div className="mb-6">
        <Wordmark size="sm" darkBg={true} />
      </div>

      <div className="flex items-center justify-center w-16 h-16 bg-green-500/10 rounded-full mb-6">
        <CheckCircle size={32} className="text-green-400" />
      </div>

      <h1 className="text-3xl font-black text-white mb-3">You're in.</h1>
      <p className="text-gray-400 text-lg max-w-sm mb-8">
        Your payment was successful. Welcome to YouSift — let's put your content library to work.
      </p>

      <a
        href="/"
        className="inline-flex items-center gap-2 px-8 py-4 bg-[#FF0000] hover:bg-[#CC0000] text-white font-black rounded-xl transition-all duration-200"
      >
        Start Sifting →
      </a>
    </div>
  );
}
